import React from 'react';
import cc from 'classcat';
import { type SlotProps } from 'input-otp';
import { VerificationCodeInputSlotCaret } from './components';
import './verificationCodeInputSlot.css';

export const VerificationCodeInputSlot = ({
  char,
  hasFakeCaret,
  isActive,
  placeholderChar = '-'
}: SlotProps) => (
  <div
    className={cc([
      'verificationCodeInputSlot',
      { 'verificationCodeInputSlot--is-current': isActive }
    ])}
  >
    {char && <div>{char}</div>}

    {!char && hasFakeCaret && <VerificationCodeInputSlotCaret />}

    {!char && !hasFakeCaret && (
      <div className="verificationCodeInputSlot__placeholder">{placeholderChar}</div>
    )}
  </div>
);
